"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCssSize = void 0;
/**
 * Добавит ед./изм. value + px, если передан number
 */
exports.toCssSize = function (value) { return (typeof value === 'number' ? value + "px" : value); };
//# sourceMappingURL=toCssSize.js.map